module.exports = __webpack_public_path__ + "static/media/icon_66.e9dc4e01.svg";